import React from 'react';
import CloseIcon from 'components/pure/utils/icon/CloseIcon';
import CrmSelectionContainer from './CrmSelectionContainer';
import TriggerIconButton from 'components/triggers/TriggerIconButton';
import CrmOpportunityActions from 'actions/crm-opp-ui/CrmOpportunityActions';
import CrmOpportunityStore from 'stores/crm-opp-ui/CrmOpportunityStore';
import connectToStores from 'alt-utils/lib/connectToStores';
import {CallConditionType} from 'records/CallTrigger';
import CrmAccountActions from 'actions/crm-opp-ui/CrmAccountActions';
import CrmAccountStore from 'stores/crm-opp-ui/CrmAccountStore';
import CrmContactActions from 'actions/crm-opp-ui/CrmContactActions';
import CrmContactStore from 'stores/crm-opp-ui/CrmContactStore';

class CrmSelectionViewRow extends React.Component {
  constructor(props) {
    super(props);

    this.showSelection = this.showSelection.bind(this);
    this.closeSelection = this.closeSelection.bind(this);
    this.saveSelection = this.saveSelection.bind(this);

    this.state = {
      selectionVisible: false,
      previousContext: null,
    };
  }

  showSelection() {
    this.setState({
      selectionVisible: true,
    });
  }

  closeSelection() {
    this.setState({
      selectionVisible: false,
    });
    if (this.state.previousContext) {
      this.props.updateContext(this.state.previousContext);
    }
  }

  saveSelection(context, close = true) {
    if (close) {
      this.setState({
        selectionVisible: false,
        previousContext: context,
      });
    }
    this.props.updateContext(context);
  }

  componentDidMount() {
    if (this.props.context) {
      this.setState({previousContext: this.props.context});
    }
  }

  renderDescription(context, defaultText) {
    if (context.type === CallConditionType.AT_OPPORTUNITY_STAGE) {
      return <OpportunityStageViewComponent context={context} onClick={this.showSelection} />;
    }

    if (context.type === CallConditionType.HAVING_OPPORTUNITY_AMOUNT) {
      return <OpportunityAmountRangeViewComponent context={context} onClick={this.showSelection} />;
    }

    if (context.type === CallConditionType.TO_ACCOUNT) {
      return <AccountViewComponent context={context} onClick={this.showSelection} />;
    }

    if (context.type === CallConditionType.WITH_CONTACT) {
      return <ContactViewComponent context={context} onClick={this.showSelection} />;
    }

    if (context.type === CallConditionType.FOR_OPPORTUNITY) {
      return <OpportunityViewComponent context={context} onClick={this.showSelection} />;
    }

    return <span>{defaultText}</span>;
  }

  render() {
    const {context, label, defaultText} = this.props;
    return (
      <div className="crm-selection">
        {label}
        {this.renderDescription(context, defaultText)}
        {this.state.selectionVisible && (
          <div className="create-rule-popout edit-popout">
            <CrmSelectionContainer
              saveSelection={this.saveSelection}
              updateSelection={context => this.saveSelection(context, false)}
              saveOnSelect={false}
              closeRequest={this.closeSelection}
              selectedContextType={context && context.type}
              selectedValue={context && context.getValue()}
            />
          </div>
        )}
      </div>
    );
  }
}

@connectToStores
class OpportunityStageViewComponent extends React.Component {
  static getStores() {
    return [CrmOpportunityStore];
  }

  static getPropsFromStores(nextProps) {
    const {context} = nextProps;
    if (!context) {
      return null;
    }
    const opportunityState = CrmOpportunityStore.getState();
    const stages = opportunityState.stages || [];
    const stageOption = stages.find(stage => stage.id === context.crmStageId);
    return {stageOption};
  }

  componentDidMount() {
    CrmOpportunityActions.fetchStages();
  }

  render() {
    return (
      <span>
        is from an Opportunity at{' '}
        <span className="condition-action" onClick={this.props.onClick}>
          stage "{this.props.stageOption && this.props.stageOption.clientName}"
        </span>
      </span>
    );
  }
}

class OpportunityAmountRangeViewComponent extends React.Component {
  render() {
    const {start, end} = this.props.context.dollarRange;
    return (
      <span>
        is part of an Opportunity{' '}
        <span className="condition-action" onClick={this.props.onClick}>
          with a projected amount {start === end ? `of $${start}` : `between $${start} and $${end}`}
        </span>
      </span>
    );
  }
}

@connectToStores
class OpportunityViewComponent extends React.Component {
  componentDidMount() {
    CrmOpportunityActions.fetchOpportunity.defer(this.props.context.crmEngagementId);
  }

  static getStores() {
    return [CrmOpportunityStore];
  }

  static getPropsFromStores(nextProps) {
    const {context} = nextProps;
    if (!context) {
      return null;
    }
    const opportunityState = CrmOpportunityStore.getState();
    return {
      opportunity: opportunityState.opportunities.get(context.crmEngagementId),
    };
  }

  render() {
    const {opportunity} = this.props;
    return (
      <span>
        is part of{' '}
        <span className="condition-action" onClick={this.props.onClick}>
          {opportunity && opportunity.name}
        </span>
      </span>
    );
  }
}

@connectToStores
class AccountViewComponent extends React.Component {
  componentDidMount() {
    CrmAccountActions.fetchAccount.defer(this.props.context.crmAccountId);
  }

  static getStores() {
    return [CrmAccountStore];
  }

  static getPropsFromStores(nextProps) {
    const {context} = nextProps;
    if (!context) {
      return null;
    }
    const accountState = CrmAccountStore.getState();
    return {account: accountState.accounts.get(context.crmAccountId)};
  }

  render() {
    const {account} = this.props;
    return (
      <span>
        is with{' '}
        <span className="condition-action" onClick={this.props.onClick}>
          {account && account.name}
        </span>
      </span>
    );
  }
}

@connectToStores
class ContactViewComponent extends React.Component {
  componentDidMount() {
    CrmContactActions.fetchContact.defer(this.props.context.crmContactId);
  }

  static getStores() {
    return [CrmContactStore];
  }

  static getPropsFromStores(nextProps) {
    const {context} = nextProps;
    if (!context) {
      return null;
    }
    const contactState = CrmContactStore.getState();
    return {contact: contactState.contacts.get(context.crmContactId)};
  }

  render() {
    const {contact} = this.props;
    return (
      <span>
        is with{' '}
        <span className="condition-action" onClick={this.props.onClick}>
          {contact && contact.name}
        </span>
      </span>
    );
  }
}

class CrmSelectionView extends React.Component {
  render() {
    const {matchAny, newContext, defaultText} = this.props;
    return (
      <div className="rule-option-list">
        <ul>
          {matchAny &&
            matchAny.map((context, i) => (
              <li key={i}>
                <CrmSelectionViewRow
                  context={context}
                  label={i > 0 ? 'or ' : ''}
                  updateContext={newContext => this.props.updateItem(i, newContext)}
                />
                {i === matchAny.size - 1 && (
                  <div className="or-button" onClick={this.props.orClick}>
                    or
                  </div>
                )}
                <div className="delete" onClick={() => this.props.removeItem(i)}>
                  <CloseIcon />
                </div>
              </li>
            ))}
          {newContext != null && (
            <li>
              <CrmSelectionViewRow
                context={newContext}
                defaultText={defaultText}
                label={matchAny && matchAny.size > 0 ? 'or ' : ''}
              />
            </li>
          )}
        </ul>
      </div>
    );
  }
}

export default class CrmSelectionViewPlusButton extends React.Component {
  constructor(props) {
    super(props);

    this.toggleSelection = this.toggleSelection.bind(this);
    this.closeSelection = this.closeSelection.bind(this);
    this.saveSelection = this.saveSelection.bind(this);
    this.updateSelection = this.updateSelection.bind(this);
    this.renderDescription = this.renderDescription.bind(this);

    this.state = {
      selectionVisible: false,
      newContext: null,
    };
  }

  toggleSelection() {
    this.props.onSelect(!this.state.selectionVisible);
    const newContext = !this.state.selectionVisible ? {} : null;
    this.setState({
      selectionVisible: !this.state.selectionVisible,
      newContext,
    });
  }

  closeSelection(reason) {
    this.props.onSelect(false);
    this.setState({
      selectionVisible: false,
      newContext: null,
    });
  }

  saveSelection(context) {
    this.props.onSelect(false);
    this.setState({
      selectionVisible: false,
      newContext: null,
    });
    this.props.addItem(context);
  }

  updateSelection(context) {
    this.setState({newContext: context});
  }

  renderDescription() {
    const {newContext, selectionVisible} = this.state;
    const {matchAny} = this.props;

    return newContext == null && (!matchAny || matchAny.size === 0) ? (
      <TriggerIconButton
        className="crm-selection"
        label="has a matching account / opportunity / contact"
        onClick={this.toggleSelection}
        active={selectionVisible}
      />
    ) : (
      <CrmSelectionView
        {...this.props}
        defaultText="Has a matching account / opportunity / contact"
        newContext={newContext}
        orClick={this.toggleSelection}
      />
    );
  }

  render() {
    const {selectionVisible} = this.state;
    return (
      <div className="rule-context-view">
        {this.renderDescription()}
        {selectionVisible && (
          <div className="create-rule-popout">
            <CrmSelectionContainer
              saveSelection={this.saveSelection}
              updateSelection={this.updateSelection}
              saveOnSelect={false}
              closeRequest={this.closeSelection}
            />
          </div>
        )}
      </div>
    );
  }
}
